import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import Highlighter from "react-highlight-words";
import _, { isEqual } from "lodash";

import ViewAllUsers from "./ViewAllUsers";
import ViewAllClientUsers from "./viewAllClientUsers";
import {
    addToBreadCrumpData,
    bulkResetBreadCrumpData,
    updateBreadCrumpData,
    removeAllTags,
    checkPermission,
    addTableSliderDataToBreadcrumb
} from "../../../config/utils";
// import $ from "jquery";
import { thousandsSeparators } from "../../../config/utils";
import { CLIENT_DYNAMIC_TABLES_TAB } from "../../dynamicTables/constants";
import { REPORT_URL } from "../../../config/constants";
import { LOCK_STATUS } from "../constants";
import { InputCell } from "./table/InputCell";
import { DynamicField } from "./table/DynamicField";
import LineEditDropdown from "./table/LineEditDropdown";
import LineEditDropdownCell from "./table/LineEditDropdownCell";
import qs from "query-string";
import {
    AIAnalyseStatus,
    assetSurveyOrder,
    assetSurveyStatus,
    eqipmentList,
    eqipmentListOrder,
    recommendationSurveyOrder,
    recommendationSurveyStatus,
    surveyStatus,
    surveyTypes
} from "../../assetSurveyProject/constants";
import SelectBox from "../../images/components/SelectBox";
import CustomAudioPlayer from "../../assetSurveyProject/components/CustomAudioPlayer";
import { taskStatus } from "../../smartCharts/constants";
import DynamicAddFieldColumn from "./table/dynamicAddFieldColumn";
import indicatorIcon from "../../../assets/img/indicator-asset.svg";
import { TableCell } from "./table/TableCell";
import { CAPITAL_REQUEST_STATUS } from "../../recommendations/constants";
import { generalTaskStatus } from "../../taskManager/constants";

class Row extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            errorMessage: "",
            region: props.region,
            view: "client",
            inputValue: { ...this.props.rowData },
            setLineEditingEnabled: false
        };
    }

    componentDidUpdate = (prevProps, prevState) => {
        // if (prevProps?.rowData?.status !== this.props.rowData?.status) {
        //     ReactTooltip.rebuild();
        // }
        if (prevProps?.rowData !== this.props.rowData) {
            this.setState({ inputValue: { ...this.props.rowData } });
        }
    };

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    energyDecimalFormat = num => {
        return (Math.round(num * 100) / 100).toFixed(2);
    };

    handleRemoveClient = async () => {
        const { region } = this.state;
        await this.setState({
            region: {
                ...region,
                client_id: ""
            }
        });
        this.props.handleUpdateRegion(this.state.region);
    };

    handleRowClick = async rowData => {
        const { isRecommendationLog = false, disableRowClickBreadcrumb = false } = this.props;
        await this.props.updateSelectedRow(rowData.id);
        const {
            showInfoPage,
            match: {
                params: { section, tab, id, subTab, settingType },
                path
            },
            location: { search = "" },
            history
        } = this.props;
        let tempSearch = search;
        if (section === "projectinfo") {
            tempSearch = `?pid=${id}`;
        }
        if (section && !isRecommendationLog && !disableRowClickBreadcrumb) {
            switch (section) {
                case "regioninfo":
                    if (tab === "recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        break;
                    } else if (tab === "dashboard") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        break;
                    } else if (tab === "buildings") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        break;
                    } else if (tab === "buildingAddition") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${search}`
                        });
                        break;
                    } else if (tab === "floors") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${tempSearch}&currentSection=${section}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${tempSearch}&currentSection=${section}`
                        });
                        break;
                    } else if (tab === "reports") {
                        if (subTab === "specialReports") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (subTab === "reportParagraphs") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (subTab === "childParagraph") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        }
                        break;
                    } else if (tab === "documents") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.file_name,
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        break;
                    } else if (tab === "Electricity" || tab === "Gas" || tab === "Water" || tab === "Sewer") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.meter_type,
                            path: `/region/regioninfo/${id}/${tab}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/region/regioninfo/${id}/${tab}/basicdetails`
                        });
                        break;
                    } else if (tab === "energyStarRating") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: "Energy Star",
                            path: `/region/regioninfo/${id}/energyStarRating`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/region/regioninfo/${id}/energyStarRating/basicdetails`
                        });
                        break;
                    } else if (tab !== "assets" && tab !== "buildingLease") {
                        // -----------------------------------
                        addToBreadCrumpData({
                            key: "siteName",
                            name: rowData.name,
                            path: `/site/siteinfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/site/siteinfo/${rowData.id}/basicdetails${search}`
                        });
                        break;
                    }
                    break;
                case "allsent":
                    break;
                case "sent":
                    break;
                case "inbox":
                    break;

                case "siteinfo":
                    if (tab === "recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        break;
                    } else if (tab === "dashboard") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });

                        break;
                    } else if (tab === "buildings") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        break;
                    } else if (tab === "reports") {
                        if (subTab === "specialReports") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (subTab === "reportParagraphs") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (subTab === "childParagraph") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        }
                        break;
                    } else if (tab === "documents") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.file_name,
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        break;
                    } else if (tab === "Electricity" || tab === "Gas" || tab === "Water" || tab === "Sewer") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.meter_type,
                            path: `/site/siteinfo/${id}/${tab}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/site/siteinfo/${id}/${tab}/basicdetails`
                        });
                        break;
                    } else if (tab === "energyStarRating") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: "Energy Star",
                            path: `/site/siteinfo/${id}/energyStarRating`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/site/siteinfo/${id}/energyStarRating/basicdetails`
                        });
                        break;
                    } else if (section === "allsent" || section === "inbox" || section === "sent") {
                        addToBreadCrumpData({
                            key: "lll",
                            name: "",
                            path
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/site/siteinfo/${id}/energyStarRating/basicdetails`
                        });
                        break;
                    } else if (tab === "buildingAddition") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${search}`
                        });
                        break;
                    } else if (tab === "floors") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${tempSearch}&currentSection=${section}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${tempSearch}&currentSection=${section}`
                        });
                        break;
                    } else if (tab !== "assets" && tab !== "buildingLease" && tab !== CLIENT_DYNAMIC_TABLES_TAB) {
                        // -------------------------
                        addToBreadCrumpData({
                            key: "buildingName",
                            name: rowData.name,
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${search}`
                        });
                        break;
                    }
                    break;
                case "buildinginfo":
                    if (tab === "recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        break;
                    } else if (tab === "dashboard") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        break;
                    } else if (tab === "buildingAddition") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${search}`
                        });
                        break;
                    } else if (tab === "reports") {
                        if (subTab === "specialReports") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (subTab === "reportParagraphs") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (subTab === "childParagraph") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        }
                        break;
                    } else if (tab === "documents") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.file_name,
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        break;
                    } else if (tab === "Electricity" || tab === "Gas" || tab === "Water" || tab === "Sewer") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.meter_type,
                            path: `/building/buildinginfo/${id}/${tab}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${id}/${tab}/basicdetails`
                        });
                        break;
                    } else if (tab === "energyStarRating") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: "Energy Star",
                            path: `/building/buildinginfo/${id}/energyStarRating`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${id}/energyStarRating/basicdetails`
                        });
                        break;
                    } else if (tab !== "assets" && tab !== "buildingLease") {
                        addToBreadCrumpData({
                            key: "floorName",
                            name: rowData.name,
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${search}&currentSection=${section}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${search}&currentSection=${section}`
                        });
                        break;
                    }
                    break;
                case "projectinfo":
                    if (tab === "settings") {
                        // addToBreadCrumpData({
                        //     key: "info",
                        //     name: subTab,
                        //     path: `/project/projectinfo/${rowData.id}/settings/${settingType}/${subSection}/${subId}/${subTab}`
                        // });
                    } else if (tab === "buildingAddition") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/buildingAddition/additioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        break;
                    } else if (tab === "floors") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${tempSearch}&currentSection=${section}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/floor/floorinfo/${rowData.id}/basicdetails${tempSearch}&currentSection=${section}`
                        });
                        break;
                    } else if (tab === "recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData?.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                    } else if (tab === "cr-recommendations") {
                        const currentParams = qs.parse(search);
                        const newSearch = { ...currentParams };
                        newSearch.is_cr = true;
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails?${qs.stringify(newSearch)}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails?${qs.stringify(newSearch)}`
                        });
                    } else if (tab === "mobile-recommendations") {
                        const clientId = this.props?.clientId ?? "";

                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?c_id=${clientId}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?c_id=${clientId}`
                        });
                    } else if (tab === "sites") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/site/siteinfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/site/siteinfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    } else if (tab === "buildings") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    } else if (tab === "regions") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/region/regioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/region/regioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    } else if (tab === "dashboard") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                    } else if (tab === "reports") {
                        if (settingType === "specialReports") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (settingType === "reportParagraphs") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        } else if (settingType === "childParagraph") {
                            addToBreadCrumpData({
                                key: "Name",
                                name: rowData.name,
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                            addToBreadCrumpData({
                                key: "info",
                                name: "Basic Details",
                                path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                            });
                        }
                        break;
                    } else if (tab === "documents") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.file_name,
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        break;
                    }
                    break;
                case "buildingTypeinfo":
                    if (tab === "buildings") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        break;
                    } else {
                        addToBreadCrumpData({
                            key: "buildingTypeName",
                            name: rowData.name,
                            path: `/buildingType/buildingTypeinfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/buildingType/buildingTypeinfo/${rowData.id}/basicdetails${search}`
                        });
                        break;
                    }
                case "reportinfo":
                    addToBreadCrumpData({
                        key: "reportName",
                        name: rowData.name,
                        path: `/documents/reportinfo/${rowData.id}/maindetails`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/documents/reportinfo/${rowData.id}/maindetails`
                    });
                    break;
                case "clientinfo":
                    if (tab === "documents") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.file_name,
                            // path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                    } else if (tab === "chartProperties") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/chartProperties/info/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/chartProperties/info/${rowData.id}/basicdetails${tempSearch}`
                        });
                    } else {
                        addToBreadCrumpData({
                            key: "clientName",
                            name: rowData.name,
                            path: `/client/clientinfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/client/clientinfo/${rowData.id}/basicdetails${search}`
                        });
                    }
                    break;
                case "userinfo":
                    addToBreadCrumpData({
                        key: "buildingName",
                        name: rowData.name,
                        path: `/building/buildinginfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/user/userinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "consultancyinfo":
                    addToBreadCrumpData({
                        key: "consultancyName",
                        name: rowData.name,
                        path: `/consultancy/consultancyinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/consultancy/consultancyinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "initiativeInfo":
                    if (tab === "recommendations" || tab === "recommendation") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        break;
                    } else if (tab === "documents") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.file_name,
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        break;
                    } else {
                        addToBreadCrumpData({
                            key: "initiativeName",
                            name: rowData.name,
                            path: `/initiatives/initiativeinfo/${rowData.id}/basicdetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/initiatives/initiativeinfo/${rowData.id}/basicdetails${search}`
                        });
                    }

                    break;
                case "imageInfo":
                    if (tab === "recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                    }
                    break;
                case "assetinfo":
                    if (tab === "recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                    } else if (tab === "sites") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/site/siteinfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/site/siteinfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    } else if (tab === "buildings") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    } else if (tab === "regions") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/region/regioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/region/regioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    } else if (tab === "dashboard") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                    } else if (tab === "survey-assets") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/asset-survey-project/surveyProjectInfo/assetInfo/${rowData.id}`,
                            isInnerTab: true
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/asset-survey-project/surveyProjectInfo/assetInfo/${rowData.id}`,
                            isInnerTab: true
                        });
                    }
                    break;
                case "assetInfo":
                    if (tab === "recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`
                        });
                    }
                    if (tab === "mobile-recommendations") {
                        let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
                        const currentParams = qs.parse(search);
                        const newSearch = { ...currentParams };
                        const index = currentBreadCrumpData?.find(e => {
                            return (
                                e.key === "Name" &&
                                e.name === rowData.code &&
                                e.path?.startsWith(`/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?`)
                            );
                        });
                        if (index) {
                            updateBreadCrumpData(index?.index);
                        }
                        const allowedKeys = ["is_assignedRecom", "pid", "is_verification"];
                        const params = allowedKeys.reduce(
                            (acc, key) => {
                                const value = qs.parse(search)?.[key];
                                if (value !== undefined) acc[key] = value;
                                return acc;
                            },
                            { c_id: newSearch?.client_id }
                        );
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?${qs.stringify(params)}`,
                            isInnerTab: newSearch?.is_assignedRecom === "true" ? true : false
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?${qs.stringify(params)}`,
                            isInnerTab: newSearch?.is_assignedRecom === "true" ? true : false
                        });
                    }
                    break;
                case "energyinfo":
                    if (tab === "regions") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/region/regioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/region/regioninfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    }
                    if (tab === "sites") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/site/siteinfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/site/siteinfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    }
                    if (tab === "buildings") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.name,
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/building/buildinginfo/${rowData.id}/basicdetails${tempSearch}`
                        });
                    }

                    if (tab === "energyStarRating") {
                        // popBreadCrumpData();
                        addToBreadCrumpData({
                            key: "Name",
                            name: "Energy Star",
                            path: `${history.location.pathname}${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `${history.location.pathname}/basicdetails${search}`
                        });
                    }
                    if (tab === "Electricity") {
                        // popBreadCrumpData();

                        addToBreadCrumpData({
                            key: "Name",
                            name: "Electricity Details",
                            path: `${history.location.pathname}${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `${history.location.pathname}/basicdetails${search}`
                        });
                    }
                    if (tab === "Gas") {
                        // popBreadCrumpData();
                        addToBreadCrumpData({
                            key: "Name",
                            name: "Gas Details",
                            path: `${history.location.pathname}${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `${history.location.pathname}/basicdetails${search}`
                        });
                    }
                    if (tab === "Water") {
                        // popBreadCrumpData();
                        addToBreadCrumpData({
                            key: "Name",
                            name: "Water Details",
                            path: `${history.location.pathname}${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `${history.location.pathname}/basicdetails${search}`
                        });
                    }
                    if (tab === "Sewer") {
                        // popBreadCrumpData();
                        addToBreadCrumpData({
                            key: "Name",
                            name: "Sewer Details",
                            path: `${history.location.pathname}${search}`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `${history.location.pathname}/basicdetails${search}`
                        });
                    }
                    break;
                case "recommendationsinfo":
                    if (tab === "documents") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.file_name,
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/documents/reportinfo/${rowData.id}/maindetails`
                        });
                    }
                    if (tab === "linked-recommendations") {
                        let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
                        const index = currentBreadCrumpData?.find(
                            e =>
                                e.key === "Name" &&
                                e.name === rowData.code &&
                                e.path === `/recommendations/recommendationsinfo/${rowData.id}/maindetails`
                        );
                        if (index) {
                            updateBreadCrumpData(index?.index);
                        }
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails`
                        });
                    }
                    if (tab === "linked-cr-recommendations") {
                        let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
                        const index = currentBreadCrumpData?.find(
                            e =>
                                e.key === "Name" &&
                                e.name === rowData.code &&
                                e.path === `/recommendations/recommendationsinfo/${rowData.id}/maindetails?is_cr=true`
                        );
                        if (index) {
                            updateBreadCrumpData(index?.index);
                        }
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails?is_cr=true`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails?is_cr=true`
                        });
                    }
                    if (tab === "mobile-recommendations") {
                        let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
                        const currentParams = qs.parse(search);
                        const newSearch = { ...currentParams };
                        const index = currentBreadCrumpData?.find(e => {
                            return (
                                e.key === "Name" &&
                                e.name === rowData.code &&
                                e.path?.startsWith(`/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?`)
                            );
                        });
                        if (index) {
                            updateBreadCrumpData(index?.index);
                        }
                        const allowedKeys = ["is_assignedRecom", "pid", "is_verification"];
                        const params = allowedKeys.reduce(
                            (acc, key) => {
                                const value = qs.parse(search)?.[key];
                                if (value !== undefined) acc[key] = value;
                                return acc;
                            },
                            { c_id: newSearch?.c_id }
                        );
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?${qs.stringify(params)}`,
                            isInnerTab: newSearch?.is_assignedRecom === "true" ? true : false
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?${qs.stringify(params)}`,
                            isInnerTab: newSearch?.is_assignedRecom === "true" ? true : false
                        });
                    }
                    break;
                case "mobrecomsinfo":
                    if (tab === "mr-recommendations") {
                        let currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
                        const currentParams = qs.parse(search);
                        const newSearch = { ...currentParams };
                        const index = currentBreadCrumpData?.find(e => {
                            return (
                                e.key === "Name" &&
                                e.name === rowData.code &&
                                e.path?.startsWith(`/recommendations/recommendationsinfo/${rowData.id}/maindetails?`)
                            );
                        });
                        if (index) {
                            updateBreadCrumpData(index?.index);
                        }
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails?${qs.stringify(newSearch)}&is_mr=true`
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails?${qs.stringify(newSearch)}&is_mr=true`
                        });
                    }
                    break;
                case "subSysteminfo":
                    break;
                case "surveyProjectInfo":
                    if (subTab === "assets") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/asset-survey-project/surveyProjectInfo/assetInfo/${rowData.id}`,
                            isInnerTab: true
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/asset-survey-project/surveyProjectInfo/assetInfo/${rowData.id}`,
                            isInnerTab: true
                        });
                    }
                    if (subTab === "assigned-assets") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/assets/assetInfo/${rowData.id}/basicdetails?client_id=${rowData?.client?.id}&verification=true`,
                            isInnerTab: true
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/assets/assetInfo/${rowData.id}/basicdetails?client_id=${rowData?.client?.id}&verification=true`,
                            isInnerTab: true
                        });
                    }
                    if (subTab === "inaccessible-space") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/asset-survey-project/surveyProjectInfo/inaccessibleSpaceInfo/${rowData.id}`,
                            isInnerTab: true
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/asset-survey-project/surveyProjectInfo/inaccessibleSpaceInfo/${rowData.id}`,
                            isInnerTab: true
                        });
                    }
                    if (subTab === "app-project-info") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData?.surveyor_name,
                            path: `/surveyor-profiles/${rowData.user_id}/app-project-info/${rowData?.id}/history-basic-detail/info?survey_project_id=${rowData?.survey_project_id}&user_id=${rowData?.user_id}`,
                            isInnerTab: true
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/surveyor-profiles/${rowData.user_id}/app-project-info/${rowData?.id}/history-basic-detail/info?survey_project_id=${rowData?.survey_project_id}&user_id=${rowData?.user_id}`,
                            isInnerTab: true
                        });
                    }
                    break;
                case "surveyor-profileinfo":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData?.asset_survey_project_name ?? rowData?.survey_recommendation_project_name,
                        path: `/surveyor-profiles/${rowData.user_id}/app-project-info/${rowData?.id}/basic-detail/info?survey_project_id=${
                            rowData?.survey_project_id ?? rowData?.survey_recommendation_project_id
                        }&user_id=${rowData?.user_id}&type=${rowData?.survey_recommendation_project_id ? "FCA" : "ADC"}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/surveyor-profiles/${rowData.user_id}/app-project-info/${rowData?.id}/basic-detail/info?survey_project_id=${
                            rowData?.survey_project_id ?? rowData?.survey_recommendation_project_id
                        }&user_id=${rowData?.user_id}&type=${rowData?.survey_recommendation_project_id ? "FCA" : "ADC"}`
                    });
                    break;
                case "app-project-info":
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Detail",
                        path: `/surveyor-profiles/${rowData.user_id}/app-project-info/${rowData?.id}/history-basic-detail/info?survey_project_id=${
                            rowData?.survey_project_id ?? rowData?.survey_recommendation_project_id
                        }&user_id=${rowData?.user_id}&type=${rowData?.survey_recommendation_project_id ? "FCA" : "ADC"}`
                    });
                    break;
                case "surveyInfo":
                    if (subTab === "assigned-recommendations") {
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`,
                            isInnerTab: true
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`,
                            isInnerTab: true
                        });
                    }
                    if (subTab === "mobile-recommendations") {
                        const clientId = this.props?.clientId ?? "";
                        const allowedKeys = ["is_assignedRecom", "pid", "is_verification"];
                        const params = allowedKeys.reduce(
                            (acc, key) => {
                                const value = qs.parse(search)?.[key];
                                if (value !== undefined) acc[key] = value;
                                return acc;
                            },
                            { c_id: clientId }
                        );
                        addToBreadCrumpData({
                            key: "Name",
                            name: rowData.code,
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?${qs.stringify(params)}`,
                            isInnerTab: true
                        });
                        addToBreadCrumpData({
                            key: "info",
                            name: "Basic Details",
                            path: `/mobrecoms/mobrecomsinfo/${rowData.id}/maindetails?${qs.stringify(params)}`,
                            isInnerTab: true
                        });
                    }
                    break;
                case "project-settings-template-info":
                    break;
                default:
                    // addToBreadCrumpData({
                    //     key: "siteName",
                    //     name: rowData.name,
                    //     path: `/site/siteInfo/${rowData.id}/basicdetails${search}`
                    // });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/site/siteInfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
            }
        } else if (path && !isRecommendationLog && !disableRowClickBreadcrumb) {
            const currentBreadCrumpData = JSON.parse(sessionStorage.getItem("bc-data"));
            switch (path) {
                case "/region":
                    addToBreadCrumpData({
                        key: "regionName",
                        name: rowData.name,
                        path: `/region/regioninfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/region/regioninfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/site":
                    // addToBreadCrumpData({
                    //     key: "siteName",
                    //     name: rowData.name,
                    //     path: `/site/siteinfo/${rowData.id}/basicdetails${search}`
                    // });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/site/siteinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/building":
                    addToBreadCrumpData({
                        key: "buildingName",
                        name: rowData.name,
                        path: `/building/buildinginfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/building/buildinginfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/efci":
                    addToBreadCrumpData({
                        key: "projectName",
                        name: rowData.name,
                        path: `/efci/efciinfo/${rowData.id}/dashboard`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "EFCI Sandbox",
                        path: `/efci/efciinfo/${rowData.id}/dashboard`
                    });
                    break;
                case "/project":
                    addToBreadCrumpData({
                        key: "buildingName",
                        name: rowData.name,
                        path: `/project/projectinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/project/projectinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/energymanagement":
                    addToBreadCrumpData({
                        key: "energyName",
                        name: rowData.name,
                        path: `/energymanagement/energyinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/energymanagement/energyinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/assetmanagement":
                    addToBreadCrumpData({
                        key: "assetName",
                        name: rowData.name,
                        path: `/assetmanagement/assetinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/assetmanagement/assetinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/meter":
                    addToBreadCrumpData({
                        key: "basicdetails",
                        name: "Basic Details",
                        path: `/meter/metertemplateinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/accounts":
                    addToBreadCrumpData({
                        key: "basicdetails",
                        name: "Basic Details",
                        path: `/accounts/AccountsInfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/reports":
                    addToBreadCrumpData({
                        key: "buildingName",
                        name: rowData.name,
                        path: `/reports/projectinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/reports/projectinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/recommendations":
                    addToBreadCrumpData({
                        key: "recommendationsName",
                        name: rowData.name,
                        path: `/project/projectinfo/${rowData.id}/maindetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Main Details",
                        path: `/project/projectinfo/${rowData.id}/maindetails${search}`
                    });
                    break;
                case "/settings/buildingtype":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/buildingType/buildingTypeinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/buildingType/buildingTypeinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/client":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/client/clientinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/client/clientinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/settings/user":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/user/userinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/user/userinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/consultancy":
                    addToBreadCrumpData({
                        key: "consultancyName",
                        name: rowData.name,
                        path: `/consultancy/consultancyinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/consultancy/consultancyinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/initiatives":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/initiatives/initiativeInfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/initiatives/initiativeInfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/documents":
                    addToBreadCrumpData({
                        key: "reportName",
                        name: rowData.file_name,
                        path: `/documents/reportinfo/${rowData.id}/maindetails`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/documents/reportinfo/${rowData.id}/maindetails`
                    });
                    break;
                case "/trade":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/trade/tradeinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/trade/tradeinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/system":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/system/systeminfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/system/systeminfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/subsystem":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/subsystem/subSysteminfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/subsystem/subSysteminfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/narrativetemplate":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/narrativetemplate/narrativetemplateinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/narrativetemplate/narrativetemplateinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/tabletemplate":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/tabletemplate/tabletemplateinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/tabletemplate/tabletemplateinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/reportnotetemplate":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/reportnotetemplate/reportnotetemplateinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/reportnotetemplate/reportnotetemplateinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/specialreport":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/specialreport/specialreportinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/reportparagraph":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/reportparagraph/reportparagraphinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/childparagraph":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/childparagraph/childparagraphinfo/${rowData.id}/basicdetails${search}`
                    });
                    break;
                case "/dashboard":
                    let bc = [
                        { key: "dashboard", name: "Dashboard", path: "/dashboard", index: 0 },
                        {
                            key: "Name",
                            name: rowData.code,
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`,
                            index: 1
                        },
                        {
                            key: "info",
                            name: "Main Details",
                            path: `/recommendations/recommendationsinfo/${rowData.id}/maindetails${search}`,
                            index: 1
                        }
                    ];
                    bulkResetBreadCrumpData(bc);
                    break;
                case "/chartProperties":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData?.name,
                        path: `/chartProperties/info/${rowData.id}/basicdetails`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/chartProperties/info/${rowData.id}/basicdetails`
                    });
                    break;
                case "/settings/notifications":
                    addToBreadCrumpData({
                        key: "info",
                        name: "Qa/Qc"
                    });
                    break;
                case "/survey-template":
                    if (!currentBreadCrumpData?.[0]?.tableSliderData) {
                        const templateData = this.props?.tableDataList || [];
                        if (templateData?.length) {
                            addTableSliderDataToBreadcrumb(templateData ?? []);
                        }
                    }
                    if (currentBreadCrumpData?.length === 1) {
                        addToBreadCrumpData({ key: "survey-templates", name: "Asset Survey Templates", path: "/survey-template" });
                    }
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.code,
                        path: `/survey-template/surveyInfo/${rowData.id}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/survey-template/surveyInfo/${rowData.id}`
                    });
                    break;
                case "/project-template":
                    if (!currentBreadCrumpData?.[0]?.tableSliderData) {
                        const templateList = this.props?.tableDataList || [];
                        if (templateList?.length) {
                            addTableSliderDataToBreadcrumb(templateList ?? []);
                        }
                    }
                    if (currentBreadCrumpData?.length === 1) {
                        addToBreadCrumpData({ key: "project-templates", name: "FCA Survey Projects", path: "/project-template" });
                    }
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.code,
                        path: `/project-template/surveyInfo/survey/${rowData.id}?is_assignedRecom=true&pid=${rowData?.project_id}${
                            rowData?.survey_type === 2 ? "&verification=true" : ""
                        }`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/project-template/surveyInfo/survey/${rowData.id}?is_assignedRecom=true&pid=${rowData?.project_id}${
                            rowData?.survey_type === 2 ? "&verification=true" : ""
                        }`
                    });
                    break;
                case "/global-project-template":
                    if (currentBreadCrumpData?.length === 1) {
                        addToBreadCrumpData({ key: "project-templates", name: "FCA Survey Projects", path: "/project-template" });
                    }
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.code,
                        path: `/global-project-template/surveyInfo/${rowData.id}`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Basic Details",
                        path: `/global-project-template/surveyInfo/${rowData.id}`
                    });
                    break;
                case "/surveyor-profiles":
                    addToBreadCrumpData({
                        key: "Name",
                        name: rowData.name,
                        path: `/surveyor-profiles/surveyor-profileinfo/${rowData.id}/app-info`
                    });
                    addToBreadCrumpData({
                        key: "info",
                        name: "Surveyor App Info",
                        path: `/surveyor-profiles/surveyor-profileinfo/${rowData.id}/app-info`
                    });
                    break;

                default:
                    break;
            }
        }
        showInfoPage(rowData.id, rowData.project_id, rowData);
    };

    hadleEditButtonClick = async (rowId, row) => {
        await this.props.updateSelectedRow(rowId);
        await this.props.showEditPage(rowId, row);
    };
    hadleEditNoteClick = async rowId => {
        await this.props.updateSelectedRow(rowId);
        await this.props.showEditExportPage(rowId);
    };

    handleRestoreButtonClick = async rowId => {
        await this.props.updateSelectedRow(rowId);
        await this.props.showRestoreModal(rowId);
    };

    escapeRegExp = string => {
        return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    };

    setSearchKeysArray = () => {
        const { tableParams = {}, findAndReplaceParams = null } = this.props;
        let returnArray = [];
        if (tableParams && tableParams.search) {
            let searchStr = tableParams.search.toString();
            if (searchStr?.includes("&&") || searchStr?.includes("~~")) {
                returnArray.push(...searchStr.split(/\s*(?:&&|~~)\s*/).filter(str => str.trim() !== ""));
            } else {
                returnArray.push(tableParams.search?.toString());
            }
        }
        if (tableParams && tableParams.filters && !_.isEmpty(tableParams.filters)) {
            const filters = Object.keys(tableParams.filters);
            for (const item of filters) {
                if (tableParams.filters[item] && tableParams.filters[item].key && tableParams.filters[item].key.length) {
                    if (tableParams.filters[item].filters[0] === "like") {
                        returnArray = returnArray.concat(tableParams.filters[item].key.toString().split("_").join("").split("%").join("").split("~"));
                    } else if (tableParams.filters[item].key.toString().includes("~")) {
                        returnArray = returnArray.concat(tableParams.filters[item].key.toString().split("~"));
                    } else {
                        returnArray.push(tableParams.filters[item].key.toString());
                    }
                }
            }
        }
        returnArray = returnArray.map(term => this.escapeRegExp(term));
        if (findAndReplaceParams?.find) {
            const findValue = this.escapeRegExp(findAndReplaceParams.find.toString());
            returnArray.push(findAndReplaceParams?.match_entire_cell ? `^${findValue}$` : findValue);
        }

        return returnArray;
    };

    isFindAndReplaceField = (searchKey, keyItem) => {
        const { findAndReplaceParams = null, config = {} } = this.props;
        const replaceFields = findAndReplaceParams?.replace_fields || [];
        if (!findAndReplaceParams?.find || !replaceFields?.length) return false;

        const fieldKeys = [
            searchKey,
            keyItem,
            config?.[keyItem]?.searchKey,
            config?.[keyItem]?.isDynamicField ? `dynamic_fields.${keyItem}` : null
        ].filter(Boolean);
        return replaceFields.some(field => fieldKeys.includes(field));
    };

    filterHighlighter = (searchKey, keyItem) => {
        let returnVal = false;
        if (this.props.tableParams && this.props.tableParams.filters) {
            Object.keys(this.props.tableParams.filters).map(fill => {
                if (fill === searchKey && this.props.tableParams?.filters[searchKey].key && this.props.tableParams?.filters[searchKey].key.length) {
                    returnVal = true;
                }
            });
        }
        if (this.props.tableParams && this.props.tableParams.search && this.props.tableParams?.search?.length) {
            returnVal = true;
        }
        if (this.isFindAndReplaceField(searchKey, keyItem)) {
            returnVal = true;
        }
        return returnVal;
    };

    handleViewUsers = (viewData, id) => {
        this.setState({
            view: viewData
        });
        this.props.updateCurrentViewAllUsers(id);
    };

    findPriorityText = (element, value) => {
        const { priorityElementsData = [] } = this.props;
        if (priorityElementsData.length && element) {
            let currentIndex = parseInt(element[element.length - 1]);
            let currentPriorityElement = priorityElementsData[currentIndex - 1];
            if (currentPriorityElement?.options?.length) {
                let selectedValue = currentPriorityElement.options.find(op => op.id === value);
                return selectedValue?.name || "-";
            }
        }
        return value;
    };

    handleCellValueChange = (value, keyItem) => {
        this.setState({ inputValue: { ...this.state.inputValue, [keyItem]: value } }, () => {
            if (keyItem === "area" || keyItem === "cost") {
                this.handleChangeCRV();
            }
        });
    };
    handleChangeCRV = () => {
        const { area = 0, cost = 0 } = this.state.inputValue || {};
        const crv = parseFloat(area) * parseFloat(cost);
        this.setState({ inputValue: { ...this.state.inputValue, crv } });
    };

    setCellValueChange = (keyItem, rowIndex, filterIdKey, isDropdownLineEdit, name) => {
        const { inputValue } = this.state;
        const { rowData, handleCellFocus, handleCellValueChange, config } = this.props;
        const hasPendingValue = Object.prototype.hasOwnProperty.call(inputValue, keyItem);
        handleCellFocus("", "");
        if (!isDropdownLineEdit && !hasPendingValue) return;
        if (!_.isEqual(inputValue[keyItem], this.getCurrentCellComparableValue(keyItem, rowData, isDropdownLineEdit))) {
            handleCellValueChange(this.state.inputValue, keyItem, rowIndex, filterIdKey, isDropdownLineEdit, name, config[keyItem]);
        }
    };

    hasLineEdit = keyItem => {
        const { config, rowData } = this.props;
        return typeof config[keyItem].hasLineEdit === "function" ? config[keyItem].hasLineEdit(rowData) : config[keyItem].hasLineEdit;
    };

    handleLineEditDropdownSelect = (keyItem, rowIndex, id, name) => {
        const { config } = this.props;
        this.setState(
            prevState => ({
                inputValue: { ...prevState.inputValue, [keyItem]: id }
            }),
            () => {
                this.setCellValueChange(
                    keyItem,
                    rowIndex,
                    config[keyItem]?.filterIdKey,
                    true,
                    name != null ? String(name).trim() : name
                );
            }
        );
    };

    normalizeBooleanValue = value => {
        if (value === "" || value == null) return null;
        if (value === true || value === "true" || value === "yes" || value === "Yes" || value === 1 || value === "1") return true;
        if (value === false || value === "false" || value === "no" || value === "No" || value === 0 || value === "0") return false;
        return value;
    };

    getCurrentFieldState = (keyItem, rowData) =>
        rowData?.dynamic_fields?.[keyItem] || rowData?.asset_static_fields?.[keyItem] || rowData?.asset_dynamic_fields?.[keyItem] || {};

    getCurrentCellComparableValue = (keyItem, rowData, isDropdownLineEdit = false) => {
        const { config } = this.props;
        const cellConfig = config?.[keyItem] || {};
        const fieldState = this.getCurrentFieldState(keyItem, rowData);

        if (cellConfig?.isDynamicField) {
            if (isDropdownLineEdit && cellConfig?.type !== "boolean") return fieldState?.uuid ?? "";
            if (cellConfig?.type === "boolean") return this.normalizeBooleanValue(fieldState?.value);
            return fieldState?.value;
        }

        if (isDropdownLineEdit) {
            if (cellConfig?.type === "boolean") return this.normalizeBooleanValue(rowData?.[keyItem]);
            if (keyItem === "status") return rowData?.[keyItem]?.id ?? rowData?.[keyItem];
            if (typeof rowData?.[keyItem] === "object") return rowData?.[keyItem]?.id ?? rowData?.[keyItem]?.uuid ?? rowData?.[keyItem]?.value;
        }

        const accessor = cellConfig?.accessor;
        return typeof accessor === "function" ? accessor(rowData) : rowData?.[keyItem];
    };

    computeClosedLabel = (keyItem, rowData) => {
        const { config } = this.props;
        if (!config?.[keyItem] || rowData == null) return "";

        if (keyItem?.startsWith("priority_element")) {
            const text = this.findPriorityText(keyItem, rowData[keyItem]);
            return text && text !== "-" ? String(text) : "";
        }

        if (keyItem === "status") {
            return rowData?.[keyItem]?.name || (typeof rowData?.[keyItem] === "string" ? rowData[keyItem] : "") || "";
        }

        const isBooleanField = config[keyItem]?.type === "boolean";

        if (config[keyItem].isDynamicField) {
            const v = rowData?.dynamic_fields?.[keyItem]?.value;
            if (isBooleanField) {
                if (v === true || v === "true" || v === "yes" || v === "Yes" || v === 1 || v === "1") return "Yes";
                if (v === false || v === "false" || v === "no" || v === "No" || v === 0 || v === "0") return "No";
                return "";
            }
            return v != null && v !== "" ? String(v) : "";
        }

        if (isBooleanField) {
            const v = rowData?.[keyItem];
            if (v === true || v === "true" || v === "yes" || v === "Yes" || v === 1 || v === "1") return "Yes";
            if (v === false || v === "false" || v === "no" || v === "No" || v === 0 || v === "0") return "No";
            return "";
        }

        if (keyItem === "manufacturer") {
            const m = rowData?.asset?.[keyItem];
            if (m == null) return "";
            return typeof m === "object" ? (m?.name || "") : String(m);
        }

        const raw = rowData?.[keyItem];
        if (raw == null) return "";
        if (typeof raw === "object") return raw?.name ? String(raw.name) : "";
        return String(raw);
    };

    render() {
        const integerValues = [
            "project_total",
            "project_costs",
            // "quantity",
            "area",
            "total_area",
            "priority",
            "fca_cost",
            "actual_cost",
            "funding",
            "total_sf",
            "recommendations_cost",
            "options_cost"
        ];
        const floatValues = ["cost", "crv", "window_sf", "climate_zone", "sf_by_ton_standard", "sf_by_ton_actual", "unit_cost"];

        const priorityElements = [
            "priority_element1",
            "priority_element2",
            "priority_element3",
            "priority_element4",
            "priority_element5",
            "priority_element6",
            "priority_element7",
            "priority_element8"
        ];

        const {
            rowData,
            keys,
            config,
            currentViewAllUsers,
            handleDeleteItem,
            hasEndTask,
            hasLog,
            selectedRowId,
            updateSelectedRow,
            hasInfoPage = true,
            hasActionColumn = true,
            isBuildingLocked,
            showRestoreModal,
            isImportHistory = false,
            handleDownloadItem,
            handleDownloadItemImport,
            handleToggleSlider,
            permissions,
            hasAssignToTrade = false,
            hasAssignToSystem = false,
            hasAssignToSubSystem = false,
            handleAssignToTrade,
            handleAssignToSystem,
            handleAssignToSubSystem,
            hasExport = false,
            isReportTemplate = false,
            handleSpecialReportActions = false,
            selectedRecomIds = [],
            hasAssignToSpecialReport = null,
            hasAssignToReportParagraph = null,
            hasAssignToChildParagraph = null,
            hasMultiAction = false,
            hasTableImport = false,
            hasTabActive = true,
            rowIndex,
            isInputMode,
            handleCellFocus,
            lineEditingEnabled: lineEditingEnabledProp,
            isCRSelection = false,
            isShiftHistory,
            isRecommendationLog = false,
            viewOnly = false,
            isRecommendationTable = false,
            isImportHistoryTable = false,
            hasSurveyAssign = false,
            handleSurveyAssign,
            assignedRows = [],
            initialSelectedAssets = [],
            isAssetMngView = false,
            isAssetSurvey = false,
            selectedMultiRow = [],
            isRecomSurvey = false,
            isSurveybasedRecoms = false,
            hasErrorLog,
            hasViewLog = false,
            hasDownloadLog = false,
            findAndReplaceParams = null
        } = this.props;
        let { hasEdit = true, hasDelete = true } = this.props;
        const lineEditingEnabled = lineEditingEnabledProp && !(this.props?.isSurveyRecom && rowData?.status === 4);
        let columnCount = 2;
        let searchKeysArray = this.setSearchKeysArray();
        let numberSearchArray = [];
        if (searchKeysArray && searchKeysArray.length) {
            searchKeysArray.map(sa => {
                var x = Number(sa.toLocaleString());
                if (isNaN(x)) {
                    numberSearchArray.push(sa);
                } else {
                    numberSearchArray.push(x.toLocaleString());
                }
            });
        }
        const locked = rowData?.is_survey_lock
            ? rowData.is_survey_lock
            : rowData.lock_status
              ? rowData.lock_status === LOCK_STATUS.LOCKED
              : rowData.locked;
        const initialPath = this.props?.location?.pathname?.split("/")?.[1];
        if (initialPath === "capital-request" && rowData?.archived) {
            hasEdit = false;
            hasDelete = false;
        }
        let user_role = localStorage.getItem("role");
        const projectBasedMobileRecomEdit =
            (checkPermission("forms", "mobile_recommendations", "edit") &&
                (user_role === "super_admin" ? true : !checkPermission("forms", "recom_mgmt_mobile", "view"))) ||
            (checkPermission("forms", "recom_mgmt_mobile", "edit") &&
                checkPermission("forms", "recom_mgmt_mobile", "view") &&
                checkPermission("forms", "mobile_recommendations", "view") &&
                checkPermission("forms", "mobile_recommendations", "edit"));
        return (
            <React.Fragment>
                <tr
                    className={`${
                        selectedRowId === rowData.id ? "active " : rowData.deleted || rowData.status === "deleted" ? "dele" : locked ? "acpt" : ""
                    }`}
                    onClick={() => (isReportTemplate ? null : setTimeout(() => updateSelectedRow(rowData.id, true), 200))}
                    onDoubleClick={e => (hasInfoPage && isInputMode?.rowIndex !== rowIndex ? this.handleRowClick(rowData) : null)}
                >
                    {this.props.isAssignAsset ? (
                        <td className="img-sq-box seting-type checkbox-container">
                            <label class="container-checkbox cursor-hand m-0">
                                <input
                                    type="checkbox"
                                    checked={this.props.selectedAsset?.id === rowData.id}
                                    onChange={e => {
                                        this.props.handleSelectAsset(rowData, e.target.checked);
                                    }}
                                    disabled={
                                        this.props.isSurveyAsset && (rowData?.asset_survey_status === 5 || rowData?.asset_survey_project_status === 4)
                                    }
                                />
                                <span
                                    className={`checkmark ${
                                        this.props.isSurveyAsset && (rowData?.asset_survey_status === 5 || rowData?.asset_survey_project_status === 4)
                                            ? "cursor-disabled"
                                            : ""
                                    }`}
                                    data-tip={this.props.isSurveyAsset && rowData?.asset_survey_status === 5 ? `Can't edit a completed asset.` : ""}
                                    data-effect="solid"
                                    data-place="right"
                                    data-for={`table`}
                                ></span>
                            </label>
                        </td>
                    ) : this.props.match.params.section === "imageInfo" || hasMultiAction || isCRSelection ? (
                        <td className="img-sq-box seting-type checkbox-container">
                            {rowData?.asset_survey_survey_type === surveyTypes[3] && (
                                <img
                                    alt=""
                                    src={indicatorIcon}
                                    className="highlight-table-image"
                                    data-tip={`New Asset`}
                                    data-effect="solid"
                                    data-place="bottom"
                                    data-for={`table`}
                                />
                            )}
                            <label class="container-checkbox cursor-hand m-0">
                                <input
                                    type="checkbox"
                                    disabled={
                                        (this.props.isSurveyAsset &&
                                            (rowData?.asset_survey_status === 5 || rowData?.asset_survey_project_status === 4)) ||
                                        (this.props?.isSurveyRecom && rowData?.status === 4) ||
                                        viewOnly ||
                                        (isAssetSurvey &&
                                            selectedMultiRow.length > 0 &&
                                            !selectedMultiRow.some(sel => sel.consultancy_uuid === rowData?.consultancy_uuid)) ||
                                        (isRecomSurvey &&
                                            selectedMultiRow.length > 0 &&
                                            !selectedMultiRow.some(sel => sel.project_id === rowData?.project_id))
                                    }
                                    checked={selectedRecomIds?.find(item => item === rowData.id) ? true : false}
                                    onClick={e => {
                                        e.stopPropagation();
                                    }}
                                    onChange={e => {
                                        this.props.handleSelectRecom(rowData, e.target.checked);
                                    }}
                                />
                                <span
                                    className={`checkmark ${
                                        (this.props.isSurveyAsset &&
                                            (rowData?.asset_survey_status === 5 || rowData?.asset_survey_project_status === 4)) ||
                                        (this.props?.isSurveyRecom && rowData?.status === 4) ||
                                        viewOnly ||
                                        (isAssetSurvey &&
                                            selectedMultiRow.length > 0 &&
                                            !selectedMultiRow.some(sel => sel.consultancy_uuid === rowData?.consultancy_uuid)) ||
                                        (isRecomSurvey &&
                                            selectedMultiRow.length > 0 &&
                                            !selectedMultiRow.some(sel => sel.project_id === rowData?.project_id))
                                            ? "cursor-disabled"
                                            : ""
                                    }`}
                                    onClick={e => {
                                        e.stopPropagation();
                                    }}
                                    data-tip={
                                        isAssetSurvey &&
                                        selectedMultiRow.length > 0 &&
                                        !selectedMultiRow.some(sel => sel.consultancy_uuid === rowData?.consultancy_uuid)
                                            ? `Consultancy mismatch with the selected survey${selectedMultiRow?.length > 1 ? "s" : ""}`
                                            : isRecomSurvey &&
                                              selectedMultiRow.length > 0 &&
                                              !selectedMultiRow.some(sel => sel.project_id === rowData?.project_id)
                                            ? `Project mismatch with the selected survey${selectedMultiRow?.length > 1 ? "s" : ""}`
                                            : ""
                                    }
                                    data-place="right"
                                    data-effect="solid"
                                    data-for={`table`}
                                ></span>
                            </label>
                        </td>
                    ) : (
                        <td className="text-center column-sticky">
                            {hasInfoPage ? (
                                <img
                                    alt=""
                                    src="/img/sq-box.png"
                                    className="cursor-pointer"
                                    onClick={() => this.handleRowClick(rowData)}
                                    data-tip={`View details`}
                                    data-effect="solid"
                                    data-place="bottom"
                                    data-for={`table`}
                                />
                            ) : (
                                <img alt="" src="/img/sq-box.png" />
                            )}
                        </td>
                    )}
                    {keys.map((keyItem, i) => {
                        return config && config[keyItem] && config[keyItem].isVisible ? (
                            <td
                                key={i}
                                style={{ ...config[keyItem]?.style, ...config[keyItem]?.cellStyle }}
                                className={`${config[keyItem].class} overflow-txt ${config[keyItem].pinned ? "pinned" : ""} ${
                                    lineEditingEnabled && keyItem !== "color_code" && this.hasLineEdit(keyItem) && !config[keyItem].isDropdownLineEdit
                                        ? "cursor-hand"
                                        : ""
                                } notranslate`}
                                onClick={async () => {
                                    if (
                                        lineEditingEnabled &&
                                        keyItem !== "color_code" &&
                                        this.hasLineEdit(keyItem) &&
                                        !config[keyItem]?.isDropdownLineEdit
                                    ) {
                                        handleCellFocus(keyItem, rowIndex, rowData?.id, config[keyItem]?.isDropdownLineEdit, rowData);
                                    }
                                }}
                                onDoubleClick={e => {
                                    if (keyItem === "asset_survey_status") e.stopPropagation();
                                }}
                            >
                                <>
                                    {keyItem === "median_eui" ? (
                                        <span className={`${config[keyItem].class}`}>
                                            <span className="nme">
                                                <Highlighter
                                                    className="text-highlighter"
                                                    unhighlightClassName="text-unhighlight"
                                                    caseSensitive={findAndReplaceParams?.match_case || false}
                                                    searchWords={this.filterHighlighter(config[keyItem].searchKey) ? searchKeysArray : []}
                                                    textToHighlight={
                                                        rowData[keyItem].property_type ? rowData[keyItem].property_type : rowData[keyItem]
                                                    }
                                                />
                                            </span>
                                        </span>
                                    ) : lineEditingEnabled &&
                                      this.hasLineEdit(keyItem) &&
                                      isInputMode?.keyItem === keyItem &&
                                      (isInputMode?.rowId ? isInputMode?.rowId === rowData.id : isInputMode?.rowIndex === rowIndex) &&
                                      !config[keyItem].isDropdownLineEdit ? (
                                        <>
                                            <InputCell
                                                isInputMode={isInputMode}
                                                keyItem={keyItem}
                                                config={config}
                                                rowData={rowData}
                                                rowIndex={rowIndex}
                                                inputValue={this.state.inputValue}
                                                suggestionArray={this.props?.lineEditSuggestionValue || []}
                                                hasPrefixSuggestionMatch={this.props?.hasPrefixSuggestionMatch || false}
                                                setCellValueChange={this.setCellValueChange}
                                                handleCellFocus={handleCellFocus}
                                                handleCellValueChange={this.handleCellValueChange}
                                                numberSearchArray={numberSearchArray}
                                                filterHighlighter={this.filterHighlighter}
                                            />
                                        </>
                                    ) : lineEditingEnabled &&
                                      this.hasLineEdit(keyItem) &&
                                      config[keyItem]?.isDropdownLineEdit &&
                                      !config[keyItem]?.pinned ? (
                                        isInputMode?.keyItem === keyItem &&
                                        (isInputMode?.rowId ? isInputMode?.rowId === rowData.id : isInputMode?.rowIndex === rowIndex) ? (
                                            <LineEditDropdown
                                                optionsList={
                                                    config[keyItem]?.type === "boolean"
                                                          ? [
                                                                { id: true, name: "Yes" },
                                                                { id: false, name: "No" }
                                                            ]
                                                          : this.props?.lineEditDropdownValue || config[keyItem]?.options || []
                                                }
                                                isDynamicField={config[keyItem].isDynamicField}
                                                isBoolean={config[keyItem]?.type === "boolean"}
                                                isGrouped={keyItem === "status" && config[keyItem]?.isGroupedLineEdit !== false}
                                                hasSearchFunction={config[keyItem]?.hasSearchFunction}
                                                hasEmptySelect={config[keyItem].isDynamicField && !config[keyItem]?.rules?.mandatory}
                                                value={
                                                    keyItem?.startsWith("priority_element")
                                                        ? this.findPriorityText(keyItem, rowData[keyItem])
                                                        : keyItem === "status"
                                                          ? typeof rowData?.[keyItem] === "object" ? rowData?.[keyItem]?.id : rowData?.[keyItem]
                                                          : config[keyItem].isDynamicField
                                                            ? config[keyItem]?.type === "boolean"
                                                                ? this.normalizeBooleanValue(rowData?.dynamic_fields?.[keyItem]?.value)
                                                                : rowData?.dynamic_fields?.[keyItem]?.uuid ?? rowData?.dynamic_fields?.[keyItem]?.value
                                                            : keyItem === "manufacturer"
                                                              ? rowData?.asset?.[keyItem]?.name || rowData?.asset?.[keyItem]
                                                              : typeof rowData?.[keyItem] === "object"
                                                                ? rowData?.[keyItem]?.name
                                                                : rowData?.[keyItem]
                                                }
                                                displayLabel={this.computeClosedLabel(keyItem, rowData)}
                                                isLoading={this.props?.isDropdownLoading === `${rowIndex}::${keyItem}`}
                                                onSelect={(id, name) => this.handleLineEditDropdownSelect(keyItem, rowIndex, id, name)}
                                                onSearch={text => handleCellFocus(keyItem, rowIndex, rowData?.id, true, rowData, text)}
                                                onClose={() => handleCellFocus("", "")}
                                            />
                                        ) : (
                                            <LineEditDropdownCell
                                                displayLabel={this.computeClosedLabel(keyItem, rowData)}
                                                disabled={config[keyItem]?.pinned}
                                                isLoading={this.props?.isDropdownLoading === `${rowIndex}::${keyItem}`}
                                                onClick={() => handleCellFocus(keyItem, rowIndex, rowData?.id, true, rowData)}
                                            />
                                        )
                                    ) : config[keyItem].isDynamicField ? (
                                        <DynamicField
                                            config={config}
                                            keyItem={keyItem}
                                            rowData={rowData}
                                            numberSearchArray={numberSearchArray}
                                            filterHighlighter={this.filterHighlighter}
                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                        />
                                    ) : keyItem === "survey_type" ? (
                                        <>{rowData?.[keyItem] === 2 ? "Verification" : "Regular"} </>
                                    ) : config[keyItem].isDynamicAddFieldColumn ? (
                                        <DynamicAddFieldColumn
                                            dynamicField={rowData?.[keyItem]}
                                            data={rowData}
                                            handleChangeDynamicFields={this.props?.handleChangeDynamicFields}
                                            handleChangeDynamicFieldValue={this?.props?.handleChangeDynamicFieldValue}
                                        />
                                    ) : keyItem === "users" ? (
                                        <div className="img-dtl">
                                            {rowData[keyItem] && rowData[keyItem].length ? (
                                                <>
                                                    <div className="img-sec">
                                                        {rowData[keyItem].map((item, i) => (
                                                            <img key={i} alt="" src={`${item.url ? item.url : "/img/user-icon.png"}`} />
                                                        ))}
                                                    </div>
                                                    <div className="icn cursor-pointer" onClick={() => this.handleViewUsers("client", rowData.id)}>
                                                        <i className="fas fa-chevron-down" />
                                                    </div>
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </div>
                                    ) : keyItem === "client_users" ? (
                                        <div className="img-dtl">
                                            {rowData[keyItem] && rowData[keyItem].length ? (
                                                <>
                                                    <div className="img-sec">
                                                        {rowData[keyItem].map((item, i) => (
                                                            <img key={i} alt="" src={`${item.url ? item.url : "/img/user-icon.png"}`} />
                                                        ))}
                                                    </div>
                                                    <div
                                                        className="icn cursor-pointer"
                                                        onClick={() => this.handleViewUsers("consultancy", rowData.id)}
                                                    >
                                                        <i className="fas fa-chevron-down" />
                                                    </div>
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </div>
                                    ) : keyItem === "expired" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.expired}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "next_year" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.next_year}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "six_to_ten" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.six_to_ten}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "three_to_five" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.three_to_five}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "Unknown" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.Unknown}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "ten_plus" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.ten_plus}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "two_years" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.two_years}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "unknown" ? (
                                        <div>
                                            <span className="d-flex w-25 p-3" style={{ backgroundColor: `${rowData?.unknown}` || "" }}></span>
                                        </div>
                                    ) : keyItem === "color_code" ? (
                                        <div
                                            className={lineEditingEnabled && this.hasLineEdit(keyItem) ? "cursor-hand" : ""}
                                            onClick={() => lineEditingEnabled && this.hasLineEdit(keyItem) && handleCellFocus(keyItem, rowIndex)}
                                        >
                                            {rowData[keyItem] || rowData["color"] ? (
                                                <>
                                                    {rowData.color_code || rowData?.color}
                                                    <span
                                                        className="color-box-common"
                                                        style={{
                                                            background: rowData.color_code || rowData?.color
                                                        }}
                                                    ></span>
                                                </>
                                            ) : (
                                                "-"
                                            )}
                                        </div>
                                    ) : (typeof rowData[keyItem] === "object" && keyItem !== "is_present_on_site") || config[keyItem]?.accessor ? (
                                        <TableCell
                                            rowData={rowData}
                                            keyItem={keyItem}
                                            config={config}
                                            searchKeysArray={searchKeysArray}
                                            filterHighlighter={this.filterHighlighter}
                                        />
                                    ) : keyItem === "active_single_chart" ? (
                                        <label
                                            className={`switch toggle-switch mr-2 ${!hasEdit ? "cursor-disabled" : ""}`}
                                            data-tip={!rowData.active && hasEdit ? "Set As Active" : ""}
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={rowData.active}
                                                onChange={() => hasEdit && handleToggleSlider({ id: rowData.id, active: !rowData.active }, true)}
                                            />
                                            <span className={`slider round ${!hasEdit ? "cursor-disabled" : ""}`}></span>
                                        </label>
                                    ) : keyItem === "active_smart_chart" ? (
                                        <label
                                            className={`switch sm-toggle toggle-switch mr-2 ${!hasEdit ? "cursor-disabled" : ""}`}
                                            data-tip={!rowData.sm_active && hasEdit ? "Set As Active" : ""}
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={rowData.sm_active}
                                                onChange={() =>
                                                    hasEdit && handleToggleSlider({ id: rowData.id, sm_active: !rowData.sm_active }, true)
                                                }
                                            />
                                            <span className={`slider round ${!hasEdit ? "cursor-disabled" : ""}`}></span>
                                        </label>
                                    ) : keyItem === "toc_active" ? (
                                        <label
                                            className={`switch sm-toggle toggle-switch mr-2 ${!hasEdit ? "cursor-disabled" : ""}`}
                                            data-tip={!rowData.toc_active && hasEdit ? "Set As Active" : ""}
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                        >
                                            <input
                                                type="checkbox"
                                                checked={rowData.toc_active}
                                                onChange={() =>
                                                    hasEdit && handleToggleSlider({ id: rowData.id, toc_active: !rowData.toc_active }, true)
                                                }
                                            />
                                            <span className={`slider round ${!hasEdit ? "cursor-disabled" : ""}`}></span>
                                        </label>
                                    ) : keyItem === "one_pager_active" ? (
                                        <label
                                            className={`switch sm-toggle toggle-switch mr-2 ${
                                                !hasEdit || rowData.template_type !== "Client" ? "cursor-diabled" : ""
                                            }`}
                                            data-tip={
                                                hasEdit && rowData.template_type === "Client" && !rowData.one_pager_active ? "Set As Active" : ""
                                            }
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                        >
                                            <input
                                                type="checkbox"
                                                className={`${!hasEdit || rowData.template_type !== "Client" ? "cursor-diabled" : ""}`}
                                                checked={rowData.one_pager_active}
                                                onChange={() =>
                                                    rowData.template_type === "Client" &&
                                                    hasEdit &&
                                                    handleToggleSlider({ id: rowData.id, one_pager_active: !rowData.one_pager_active }, true)
                                                }
                                                disabled={!hasEdit && rowData.template_type !== "Client"}
                                            />
                                            <span
                                                className={`slider round ${!hasEdit || rowData.template_type !== "Client" ? "cursor-diabled" : ""}`}
                                            ></span>
                                        </label>
                                    ) : keyItem === "reportRegion" ? (
                                        (
                                            <>
                                                {rowData.region && rowData.region.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.region}
                                                        data-tip={rowData.region}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.region && rowData.region}
                                                    />
                                                )}
                                            </>
                                        ) || "-"
                                    ) : keyItem === "reportSite" ? (
                                        (
                                            <>
                                                {rowData.site && rowData.site.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.site}
                                                        data-tip={rowData.site}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.site}
                                                    />
                                                )}
                                            </>
                                        ) || "-"
                                    ) : [
                                          "notes",
                                          "comments",
                                          "asset_note",
                                          "asset_surveyor_comments",
                                          "cbre_review_qc_comment",
                                          "recom_surveyor_comments"
                                      ].includes(keyItem) || config[keyItem].isMemoField ? (
                                        (rowData[keyItem] && (
                                            <>
                                                {/* {rowData[keyItem] && rowData[keyItem].length > 25 ? ( */}
                                                <Highlighter
                                                    className="text-highlighter"
                                                    unhighlightClassName="text-unhighlight"
                                                    caseSensitive={findAndReplaceParams?.match_case || false}
                                                    searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                    textToHighlight={removeAllTags(rowData[keyItem])}
                                                    data-tip={keyItem === "notes" ? rowData["note_html"] : rowData[keyItem]}
                                                    data-effect="solid"
                                                    data-delay-hide="100"
                                                    data-place="bottom"
                                                    data-for={`table`}
                                                    data-class="rc-tooltip-custom-class extras"
                                                />
                                                {/* ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData[keyItem]}
                                                    />
                                                )} */}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem === "files" ? (
                                        rowData[keyItem].length ? (
                                            <>
                                                <img src="/img/atch.svg" alt="" />
                                            </>
                                        ) : (
                                            "-"
                                        )
                                    ) : integerValues.includes(keyItem) ? (
                                        rowData[keyItem] || rowData[keyItem] === 0 ? (
                                            rowData[keyItem] ? (
                                                <>
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? numberSearchArray : []
                                                        }
                                                        textToHighlight={Math.round(parseFloat(rowData[keyItem] || 0)).toLocaleString()}
                                                    />
                                                </>
                                            ) : (
                                                "0"
                                            )
                                        ) : (
                                            "-"
                                        )
                                    ) : floatValues.includes(keyItem) ? (
                                        rowData[keyItem] || rowData[keyItem] === 0 ? (
                                            rowData[keyItem] ? (
                                                <>
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? numberSearchArray : []
                                                        }
                                                        textToHighlight={parseFloat(rowData[keyItem]).toLocaleString()}
                                                    />
                                                </>
                                            ) : (
                                                "0"
                                            )
                                        ) : (
                                            "-"
                                        )
                                    ) : keyItem.includes("priority_element") && typeof rowData[keyItem] !== "object" ? (
                                        rowData[keyItem] || rowData[keyItem] === 0 ? (
                                            (rowData[keyItem] || rowData[keyItem] === 0) && this.findPriorityText(keyItem, rowData[keyItem]) ? (
                                                <>
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? numberSearchArray : []
                                                        }
                                                        textToHighlight={this.findPriorityText(keyItem, rowData[keyItem])}
                                                        data-tip={this.findPriorityText(keyItem, rowData[keyItem])}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                </>
                                            ) : (
                                                "0"
                                            )
                                        ) : (
                                            "-"
                                        )
                                    ) : keyItem === "ministry" ? (
                                        (rowData.ministry && (
                                            <>
                                                {rowData.ministry.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.ministry}
                                                        data-tip={rowData.ministry}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.ministry}
                                                    />
                                                )}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem === "notification_title" ? (
                                        (rowData.data?.title && (
                                            <>
                                                {rowData.data?.title?.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.data.title.substring(0, 25) + "..."}
                                                        data-tip={rowData.data.title}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.data.title}
                                                    />
                                                )}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem === "notification_body" ? (
                                        (rowData.data?.body && (
                                            <>
                                                {rowData.data?.body?.length > 30 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.data.body.substring(0, 30) + "..."}
                                                        data-tip={rowData.data.body}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.data.body}
                                                    />
                                                )}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem === "hospital_name_recomentation" ? (
                                        (rowData.building && rowData.building?.hospital_name && (
                                            <>
                                                {rowData.building?.hospital_name.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.hospital_name.substring(0, 25) + "..."}
                                                        data-tip={rowData.building?.hospital_name}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.hospital_name}
                                                    />
                                                )}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem === "buildingType" ? (
                                        (rowData.building?.building_type && (
                                            <>
                                                {rowData.building?.building_type.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.building_type.substring(0, 25) + "..."}
                                                        data-tip={rowData.building?.building_type}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.building_type}
                                                    />
                                                )}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem.includes("energy_band_") &&
                                      rowData[config[keyItem]?.commonSearchKey] &&
                                      rowData[config[keyItem]?.commonSearchKey][config[keyItem].commonSearchObjectKey] ? (
                                        (rowData.energy_band && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={[]}
                                                textToHighlight={rowData[config[keyItem].commonSearchKey][
                                                    config[keyItem].commonSearchObjectKey
                                                ]?.toLocaleString()}
                                                data-tip={rowData[config[keyItem].commonSearchKey][config[keyItem].commonSearchObjectKey]}
                                                data-effect="solid"
                                                data-place="bottom"
                                                data-for={`table`}
                                                data-class="rc-tooltip-custom-class"
                                            />
                                        )) ||
                                        "-"
                                    ) : keyItem.includes("water_band_") &&
                                      rowData[config[keyItem]?.commonSearchKey] &&
                                      rowData[config[keyItem]?.commonSearchKey][config[keyItem].commonSearchObjectKey] ? (
                                        (rowData.energy_band && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={[]}
                                                textToHighlight={rowData[config[keyItem].commonSearchKey][
                                                    config[keyItem].commonSearchObjectKey
                                                ]?.toLocaleString()}
                                                data-tip={rowData[config[keyItem].commonSearchKey][config[keyItem].commonSearchObjectKey]}
                                                data-effect="solid"
                                                data-place="bottom"
                                                data-for={`table`}
                                                data-class="rc-tooltip-custom-class"
                                            />
                                        )) ||
                                        "-"
                                    ) : keyItem === "client_site_id" && rowData.site?.client_site_id ? (
                                        <>
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                textToHighlight={rowData.site?.client_site_id}
                                            />
                                        </>
                                    ) : keyItem === "buildingDescription" ? (
                                        rowData.building?.building_description ? (
                                            <>
                                                {rowData.building?.building_description?.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.building_description}
                                                        data-tip={rowData.building?.building_description}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.building_description}
                                                    />
                                                )}
                                            </>
                                        ) : rowData.building?.description ? (
                                            <>
                                                {rowData.building?.description?.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.description}
                                                        data-tip={rowData.building?.description}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.building?.description}
                                                    />
                                                )}
                                            </>
                                        ) : (
                                            "-"
                                        )
                                    ) : keyItem === "mmbtu_usage" ? (
                                        (rowData.mmbtu_usage && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={thousandsSeparators(rowData[keyItem].toFixed(2)).toString()}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "mmbtu_well_head_cost" ? (
                                        (rowData.mmbtu_well_head_cost && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={`$ ${thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}`}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "mmbtu_transport_cost" ? (
                                        (rowData.mmbtu_transport_cost && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={`$ ${thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}`}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "mmbtu_total_gas_cost" ? (
                                        (rowData.mmbtu_total_gas_cost && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={`$ ${thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}`}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "kw_cost" ? (
                                        (rowData.kw_cost && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={`$ ${thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}`}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "cost_per_unit" ? (
                                        (rowData.cost_per_unit && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={`${
                                                    this.props?.match?.params?.tab === "recommendations" ? "" : "$ "
                                                }${thousandsSeparators(parseFloat(rowData[keyItem])).toString()}`}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "kw_usage" ? (
                                        (rowData.kw_usage && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "kwh_cost" ? (
                                        (rowData.kwh_cost && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={`$ ${thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}`}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "kwh_usage" ? (
                                        (rowData.kwh_usage && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "ccf_usage" ? (
                                        (rowData.ccf_usage && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "ccf_cost" ? (
                                        (rowData.ccf_cost && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "total_electric_cost" ? (
                                        (rowData.total_electric_cost && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={`$ ${thousandsSeparators(
                                                    this.energyDecimalFormat(parseFloat(rowData[keyItem]))
                                                ).toString()}`}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "request_estimate" ? (
                                        (rowData.request_estimate && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem]?.searchKey, keyItem) ? numberSearchArray : []}
                                                textToHighlight={thousandsSeparators(rowData[keyItem]).toString()}
                                            />
                                        )) ||
                                        0
                                    ) : keyItem === "import_project" ? (
                                        (rowData && (
                                            <>
                                                {rowData.project && rowData.project.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.project.substring(0, 25) + "..."}
                                                        data-tip={rowData.project}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.project}
                                                    />
                                                )}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem === "import_site" ? (
                                        (rowData && (
                                            <>
                                                {rowData.site && rowData.site.length > 25 ? (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.site.substring(0, 25) + "..."}
                                                        data-tip={rowData.site}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                        data-class="rc-tooltip-custom-class"
                                                    />
                                                ) : (
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={rowData.site}
                                                    />
                                                )}
                                            </>
                                        )) ||
                                        "-"
                                    ) : keyItem === "project" && typeof rowData[keyItem] !== "string" ? (
                                        (rowData.project
                                            ? (rowData.project.name ? rowData.project.name : rowData.project) && (
                                                  <>
                                                      {(rowData.project.name ? rowData.project.name : rowData.project).length > 25 ? (
                                                          <Highlighter
                                                              className="text-highlighter"
                                                              unhighlightClassName="text-unhighlight"
                                                              caseSensitive={findAndReplaceParams?.match_case || false}
                                                              searchWords={
                                                                  this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                              }
                                                              textToHighlight={rowData.project.name}
                                                              data-tip={rowData.project.name || rowData.project}
                                                              data-effect="solid"
                                                              data-place="bottom"
                                                              data-for={`table`}
                                                              data-class="rc-tooltip-custom-class"
                                                          />
                                                      ) : (
                                                          <Highlighter
                                                              className="text-highlighter"
                                                              unhighlightClassName="text-unhighlight"
                                                              caseSensitive={findAndReplaceParams?.match_case || false}
                                                              searchWords={
                                                                  this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                              }
                                                              textToHighlight={rowData.project.name ? rowData.project.name : rowData.project}
                                                          />
                                                      )}
                                                  </>
                                              )
                                            : "-") || "-"
                                    ) : keyItem === "inspection_date" ? (
                                        (rowData && rowData.inspection_date && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                textToHighlight={moment(rowData && rowData.inspection_date).format("MM-DD-YYYY")}
                                            />
                                        )) ||
                                        "-"
                                    ) : keyItem === "requested_date" ? (
                                        (rowData && rowData.requested_date && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                textToHighlight={moment(rowData && rowData.requested_date).format("MM-DD-YYYY")}
                                            />
                                        )) ||
                                        "-"
                                    ) : keyItem === "assessment_date" ? (
                                        (rowData && rowData.assessment_date && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                textToHighlight={moment(rowData && rowData.assessment_date).format("MM-DD-YYYY")}
                                            />
                                        )) ||
                                        "-"
                                    ) : keyItem === "survey_status" ? (
                                        <span className={`${surveyStatus?.[rowData?.[keyItem]]?.class}`}>
                                            {surveyStatus?.[rowData?.[keyItem]]?.value ?? "-"}
                                        </span>
                                    ) : (config?.[keyItem]?.isSelectDropdownField && keyItem !== "is_present_on_site") ||
                                      (config?.[keyItem]?.isSelectDropdownField &&
                                          keyItem === "is_present_on_site" &&
                                          !rowData?.dynamic_fields?.["is_the_equipment_present_on_site"]?.value) ? (
                                        <SelectBox
                                            optionsList={(keyItem === "asset_survey_status"
                                                ? assetSurveyOrder
                                                : keyItem === "is_present_on_site"
                                                ? eqipmentListOrder
                                                : recommendationSurveyOrder
                                            )?.map(id => ({
                                                id: keyItem === "is_present_on_site" ? eqipmentList?.[id].value : parseInt(id),
                                                name:
                                                    keyItem === "is_present_on_site"
                                                        ? eqipmentList?.[id].value
                                                        : config?.[keyItem]?.isMobileRecomStatus
                                                        ? recommendationSurveyStatus?.[id]?.value
                                                        : assetSurveyStatus?.[id].value,
                                                class:
                                                    keyItem === "is_present_on_site"
                                                        ? eqipmentList?.[id].class
                                                        : config?.[keyItem]?.isMobileRecomStatus
                                                        ? recommendationSurveyStatus?.[id]?.class
                                                        : assetSurveyStatus?.[id].class,
                                                disabled:
                                                    keyItem === "is_present_on_site"
                                                        ? eqipmentList?.[id]?.disabled
                                                        : config?.[keyItem]?.isMobileRecomStatus
                                                        ? recommendationSurveyStatus?.[id]?.disabled
                                                        : assetSurveyStatus?.[id]?.disabled
                                            }))}
                                            isAssetStatus={keyItem === "asset_survey_status"}
                                            value={rowData?.[keyItem]}
                                            isAssetSurveyProject
                                            isClearable={false}
                                            handleChange={value => this.props.handleSurveyStatus(value, rowData?.id, rowData)}
                                            isStatus
                                            menuPortalTarget={document.body}
                                            menuPosition="fixed"
                                            hasEmptySelect={false}
                                            rowId={rowData?.id}
                                            disabled={
                                                keyItem === "asset_survey_status"
                                                    ? rowData?.[keyItem] === 5 ||
                                                      rowData?.asset_survey_project_status === 4 ||
                                                      (isAssetMngView
                                                          ? !(
                                                                (checkPermission("forms", "mobile_assets", "edit") &&
                                                                    (user_role === "super_admin"
                                                                        ? true
                                                                        : !checkPermission("forms", "asset_mgmt_mobile", "view"))) ||
                                                                (checkPermission("forms", "asset_mgmt_mobile", "edit") &&
                                                                    checkPermission("forms", "asset_mgmt_mobile", "view") &&
                                                                    checkPermission("forms", "mobile_assets", "view") &&
                                                                    checkPermission("forms", "mobile_assets", "edit"))
                                                            )
                                                          : !checkPermission("forms", "mobile_assets", "edit"))
                                                    : config?.[keyItem]?.isMobileRecomStatus
                                                    ? (isSurveybasedRecoms
                                                          ? !checkPermission("forms", "mobile_assets", "edit")
                                                          : !projectBasedMobileRecomEdit) || rowData?.[keyItem] === 4
                                                    : rowData?.[keyItem] === 4
                                            }
                                        />
                                    ) : keyItem === "status" ? (
                                        <span className={`${taskStatus?.find(e => e.value === rowData?.[keyItem])?.class}`}>
                                            {typeof rowData?.[keyItem] === "object" ? rowData?.[keyItem]?.name : rowData?.[keyItem]}
                                        </span>
                                    ) : keyItem === "status_name" ? (
                                        <span className={`${generalTaskStatus?.find(e => e.value === rowData?.[keyItem])?.class}`}>
                                            {typeof rowData?.[keyItem] === "object" ? rowData?.[keyItem]?.name : rowData?.[keyItem]}
                                        </span>
                                    ) : config?.[keyItem]?.isAudioField ? (
                                        rowData?.[keyItem] ? (
                                            <CustomAudioPlayer src={rowData?.[keyItem]} duration={rowData?.duration} />
                                        ) : (
                                            "Processing..."
                                        )
                                    ) : config?.[keyItem]?.isVideoField ? (
                                        rowData?.[keyItem] ? (
                                            <div className="cursor-pointer" onClick={() => this.handleRowClick(rowData)}>
                                                Click Here To Play Video
                                            </div>
                                        ) : (
                                            "Processing..."
                                        )
                                    ) : keyItem === "lease_end_date" || keyItem === "start_date" || keyItem === "end_date" ? (
                                        (rowData && rowData[keyItem] && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                textToHighlight={moment(rowData && rowData?.[keyItem]).format("MM-DD-YYYY")}
                                            />
                                        )) ||
                                        "-"
                                    ) : keyItem === "assigned_bands" ? (
                                        (rowData && rowData.assigned_bands && (
                                            <Highlighter
                                                className="text-highlighter"
                                                unhighlightClassName="text-unhighlight"
                                                caseSensitive={findAndReplaceParams?.match_case || false}
                                                searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                textToHighlight={rowData.assigned_bands.join(", ") || "-"}
                                            />
                                        )) ||
                                        "-"
                                    ) : keyItem === "filter_fields" ? (
                                        (rowData && rowData.filter_fields && rowData.filter_fields.building?.toString()?.length > 20 ? (
                                            <>
                                                <Highlighter
                                                    className="text-highlighter"
                                                    unhighlightClassName="text-unhighlight"
                                                    caseSensitive={findAndReplaceParams?.match_case || false}
                                                    searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                                    textToHighlight={"BUILDING: " + rowData.filter_fields.building.toString()}
                                                    data-effect="solid"
                                                    data-tip={"<b>Building: </b>" + rowData.filter_fields.building.toString()}
                                                    data-place="bottom"
                                                    data-for={`table`}
                                                    data-class="rc-tooltip-custom-class"
                                                />
                                            </>
                                        ) : (
                                            (rowData && rowData.filter_fields && rowData.filter_fields?.building?.length > 0 && (
                                                <>
                                                    <Highlighter
                                                        className="text-highlighter"
                                                        unhighlightClassName="text-unhighlight"
                                                        caseSensitive={findAndReplaceParams?.match_case || false}
                                                        searchWords={
                                                            this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                        }
                                                        textToHighlight={"BUILDING: " + rowData.filter_fields?.building?.toString()}
                                                    />
                                                </>
                                            )) ||
                                            "-"
                                        )) || "-"
                                    ) : keyItem === "double_header" ||
                                      keyItem === "footer" ||
                                      keyItem === "is_active" ||
                                      config[keyItem].type === "boolean" ||
                                      rowData[keyItem] === "yes" ||
                                      rowData[keyItem] === "no" ? (
                                        <Highlighter
                                            className="text-highlighter"
                                            unhighlightClassName="text-unhighlight"
                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                            searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                            textToHighlight={
                                                rowData[keyItem] === true || rowData[keyItem] === "yes"
                                                    ? "Yes"
                                                    : rowData[keyItem] === false || rowData[keyItem] === "no"
                                                      ? "No"
                                                      : "-"
                                            }
                                        />
                                    ) : rowData?.[keyItem] && keyItem === "analyze_status" ? (
                                        <Highlighter
                                            className={`text-highlighter ${AIAnalyseStatus?.[rowData?.[keyItem]]?.className || ""}`}
                                            unhighlightClassName="text-unhighlight"
                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                            searchWords={
                                                this.filterHighlighter(config[keyItem].searchKey, AIAnalyseStatus?.[rowData?.[keyItem]]?.value)
                                                    ? searchKeysArray
                                                    : []
                                            }
                                            textToHighlight={AIAnalyseStatus?.[rowData?.[keyItem]]?.value}
                                            style={{ color: AIAnalyseStatus?.[rowData?.[keyItem]]?.color }}
                                        />
                                    ) : keyItem === "cr_status" ? (
                                        <Highlighter
                                            className={`text-highlighter ${
                                                CAPITAL_REQUEST_STATUS?.find(e => e.id === rowData?.[keyItem])?.class ?? ""
                                            }`}
                                            unhighlightClassName="text-unhighlight"
                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                            searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                            textToHighlight={
                                                CAPITAL_REQUEST_STATUS?.find(e => e.id === rowData?.[keyItem])?.name ?? ""
                                            }
                                        />
                                    ) : rowData[keyItem] ? (
                                        <>
                                            {typeof rowData[keyItem] === "string" ? (
                                                <>
                                                    {rowData[keyItem].length > 7 ? (
                                                        <Highlighter
                                                            className="text-highlighter"
                                                            unhighlightClassName="text-unhighlight"
                                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                                            searchWords={
                                                                this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                            }
                                                            textToHighlight={rowData[keyItem]}
                                                            data-tip={rowData[keyItem]}
                                                            data-effect="solid"
                                                            data-place="bottom"
                                                            data-for={`table`}
                                                            data-class="rc-tooltip-custom-class"
                                                        />
                                                    ) : (
                                                        <Highlighter
                                                            className="text-highlighter"
                                                            unhighlightClassName="text-unhighlight"
                                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                                            searchWords={
                                                                this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []
                                                            }
                                                            textToHighlight={rowData[keyItem]}
                                                        />
                                                    )}
                                                </>
                                            ) : typeof rowData[keyItem] === "number" && config[keyItem].type === "number" ? (
                                                rowData[keyItem] ? (
                                                    <>
                                                        <Highlighter
                                                            className="text-highlighter"
                                                            unhighlightClassName="text-unhighlight"
                                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                                            searchWords={
                                                                this.filterHighlighter(config[keyItem]?.searchKey, keyItem)
                                                                    ? keyItem === "installed_year" ||
                                                                      keyItem === "year_manufactured" ||
                                                                      keyItem === "birth_year" ||
                                                                      keyItem === "end_of_service_life" ||
                                                                      keyItem === "year" ||
                                                                      keyItem === "source_year" ||
                                                                      keyItem === "target_year" ||
                                                                      keyItem === "major_renovation_year"
                                                                        ? numberSearchArray.map(arr => arr.replace(",", ""))
                                                                        : numberSearchArray
                                                                    : []
                                                            }
                                                            textToHighlight={
                                                                keyItem === "installed_year" ||
                                                                keyItem === "year_manufactured" ||
                                                                keyItem === "birth_year" ||
                                                                keyItem === "end_of_service_life" ||
                                                                keyItem === "year" ||
                                                                keyItem === "source_year" ||
                                                                keyItem === "target_year" ||
                                                                keyItem === "major_renovation_year"
                                                                    ? rowData[keyItem].toString()
                                                                    : rowData[keyItem].toLocaleString()
                                                            }
                                                        />
                                                    </>
                                                ) : (
                                                    "-"
                                                )
                                            ) : (
                                                <Highlighter
                                                    className="text-highlighter"
                                                    unhighlightClassName="text-unhighlight"
                                                    caseSensitive={findAndReplaceParams?.match_case || false}
                                                    searchWords={
                                                        this.filterHighlighter(config[keyItem]?.searchKey, keyItem)
                                                            ? keyItem === "year" || keyItem === "major_renovation_year"
                                                                ? numberSearchArray.map(arr => arr.replace(",", ""))
                                                                : numberSearchArray
                                                            : []
                                                    }
                                                    textToHighlight={rowData[keyItem].toString()}
                                                />
                                            )}
                                        </>
                                    ) : (keyItem === "recommendation_code" || keyItem === "recom_desc" || keyItem === "user_name") &&
                                      this.props?.isRecommendationLog ? (
                                        <Highlighter
                                            className="text-highlighter rc-tooltip-custom-class"
                                            unhighlightClassName="text-unhighlight"
                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                            searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : []}
                                            textToHighlight={
                                                keyItem === "user_name"
                                                    ? rowData?.user?.name?.toString()
                                                    : keyItem === "recom_desc"
                                                    ? rowData?.recommendation?.description.toString()
                                                    : rowData?.recommendation?.code.toString()
                                            }
                                            data-for={`table`}
                                            data-tip={
                                                keyItem === "user_name"
                                                    ? rowData?.user?.name?.toString()
                                                    : keyItem === "recom_desc"
                                                    ? rowData?.recommendation?.description.toString()
                                                    : rowData?.recommendation?.code.toString()
                                            }
                                            data-effect="solid"
                                            data-place="bottom"
                                        />
                                    ) : keyItem === "client_standards_description" ? (
                                        <Highlighter
                                            className="text-highlighter"
                                            unhighlightClassName="text-unhighlight"
                                            caseSensitive={findAndReplaceParams?.match_case || false}
                                            searchWords={this.filterHighlighter(config[keyItem].searchKey, keyItem) ? searchKeysArray : [] || []}
                                            textToHighlight={rowData?.client_standards?.description || "-"}
                                            {...(rowData?.client_standards?.description?.length > 25 && {
                                                "data-tip": rowData?.client_standards?.description || "",
                                                "data-effect": "solid",
                                                "data-place": "bottom",
                                                "data-for": `table-row${rowData.id}`,
                                                "data-class": "rc-tooltip-custom-class"
                                            })}
                                        />
                                    ) : (
                                        <>
                                            {typeof rowData[keyItem] === "string" || rowData[keyItem] === null
                                                ? "-"
                                                : config[keyItem].type === "number"
                                                ? rowData[keyItem] ?? "-"
                                                : "-"}
                                        </>
                                    )}
                                </>
                            </td>
                        ) : null;
                    })}
                    {hasActionColumn && !isBuildingLocked ? (
                        <td className="bg-white ">
                            {isImportHistory ? (
                                <li className="dropdown dot-icn-arw">
                                    <span
                                        onClick={() => handleDownloadItem(rowData.log_url, rowData.name, "logView")}
                                        data-tip="View Log"
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-for={`table`}
                                    >
                                        <i className="far fa-eye" />
                                    </span>
                                    <span
                                        onClick={() => handleDownloadItem(rowData.log_url, rowData.log_name, "logDownload")}
                                        data-tip="Download Log"
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-for={`table`}
                                    >
                                        <i className="fas fa-file-download" />
                                    </span>
                                    <span
                                        onClick={() => handleDownloadItem(rowData.url, rowData.name)}
                                        data-tip="Download Excel File"
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-for={`table`}
                                    >
                                        <i className="fas fa-file-download" />
                                    </span>
                                    <span
                                        onClick={() => handleDeleteItem(rowData.id)}
                                        data-tip="Delete"
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-for={`table`}
                                    >
                                        <i className="far fa-trash-alt" />
                                    </span>
                                </li>
                            ) : isShiftHistory ? (
                                <li className="dropdown dot-icn-arw">
                                    <span
                                        onClick={() => handleDownloadItem(rowData.log_url, rowData.name, "logView")}
                                        data-tip="View Log"
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-for={`table`}
                                    >
                                        <i className="far fa-eye" />
                                    </span>
                                    <span
                                        onClick={() => handleDownloadItem(rowData.log_url, rowData.log_name, "logDownload")}
                                        data-tip="Download Log"
                                        data-effect="solid"
                                        data-place="bottom"
                                        data-for={`table`}
                                    >
                                        <i className="fas fa-file-download" />
                                    </span>
                                    {hasDelete && (
                                        <span
                                            onClick={() => handleDeleteItem(rowData.id)}
                                            data-tip="Delete"
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                        >
                                            <i className="far fa-trash-alt" />
                                        </span>
                                    )}
                                </li>
                            ) : hasTableImport ? (
                                <li className="dropdown dot-icn-arw">
                                    {hasEdit && (
                                        <span
                                            onClick={() => {
                                                this.hadleEditNoteClick(rowData);
                                            }}
                                        >
                                            <i
                                                className="fas fa-pencil-alt f-14"
                                                data-tip={`Edit`}
                                                data-effect="solid"
                                                data-place="bottom"
                                                data-for={`table`}
                                            />
                                        </span>
                                    )}
                                    {hasDelete && (
                                        <span
                                            onClick={() => handleDeleteItem(rowData.id)}
                                            data-tip="Delete"
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                        >
                                            <i className="far fa-trash-alt" />
                                        </span>
                                    )}
                                    {rowData.status === "completed" && hasExport && (
                                        <span
                                            onClick={() => handleDownloadItemImport(rowData.doc_url, rowData.doc_name, "wordDownload")}
                                            data-tip={isImportHistoryTable ? "Download File" : "Download Word"}
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                        >
                                            <i className="fas fa-file-download" />
                                        </span>
                                    )}
                                </li>
                            ) : isReportTemplate ? (
                                <>
                                    <li className="dropdown dot-icn-arw">
                                        {rowData.deleted ? (
                                            <span
                                                onClick={() => {
                                                    showRestoreModal(rowData.id);
                                                }}
                                            >
                                                <i
                                                    className="fas fa-undo"
                                                    data-tip={`Restore`}
                                                    data-effect="solid"
                                                    data-place="bottom"
                                                    data-for={`table`}
                                                />
                                            </span>
                                        ) : (
                                            hasEdit && (
                                                <span
                                                    onClick={() => {
                                                        this.hadleEditButtonClick(rowData);
                                                    }}
                                                >
                                                    <i
                                                        className="fas fa-pencil-alt f-14"
                                                        data-tip={`Edit`}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    />
                                                </span>
                                            )
                                        )}
                                        {hasExport && (
                                            <span
                                                onClick={() =>
                                                    handleDownloadItem(
                                                        rowData.doc_url
                                                            ? rowData.doc_url
                                                            : rowData?.s3_file
                                                            ? rowData.s3_file
                                                            : REPORT_URL + (rowData.template_file || rowData.file)
                                                    )
                                                }
                                                data-tip="Download"
                                                data-effect="solid"
                                                data-place="bottom"
                                                data-for={`table`}
                                            >
                                                <i className="fas fa-file-download f-17" />
                                            </span>
                                        )}

                                        {!rowData.deleted && hasDelete && (
                                            <span
                                                onClick={() =>
                                                    !rowData.active &&
                                                    !rowData.sm_active &&
                                                    !rowData.toc_active &&
                                                    handleDeleteItem(rowData.id, rowData.deleted || false)
                                                }
                                            >
                                                <i
                                                    className={`far fa-trash-alt f-14 ml-1 ${
                                                        rowData.active || rowData.sm_active || rowData.toc_active ? "cursor-diabled" : ""
                                                    }`}
                                                    data-tip={rowData.active || rowData.sm_active || rowData.toc_active ? "" : `Delete`}
                                                    data-effect="solid"
                                                    data-place="bottom"
                                                    data-for={`table`}
                                                />
                                            </span>
                                        )}
                                    </li>
                                </>
                            ) : (
                                <li className="dropdown dot-icn-arw">
                                    {locked && !hasSurveyAssign ? (
                                        <div class="locking-center locked td-lock">
                                            <img
                                                src="/img/lock-whi.svg"
                                                alt=""
                                                class="export"
                                                data-tip={`Locked`}
                                                data-effect="solid"
                                                data-place="bottom"
                                                data-for={`table`}
                                            />
                                        </div>
                                    ) : rowData.deleted || rowData.status === "deleted" ? (
                                        permissions && permissions.restore === false ? (
                                            ""
                                        ) : (
                                            <span
                                                onClick={() => {
                                                    showRestoreModal(rowData.id);
                                                }}
                                            >
                                                <i
                                                    className="fas fa-undo"
                                                    data-tip={`Restore`}
                                                    data-effect="solid"
                                                    data-place="bottom"
                                                    data-for={`table`}
                                                />
                                            </span>
                                        )
                                    ) : (
                                        <>
                                            {hasViewLog && rowData?.log_file && (
                                                <span onClick={() => hasViewLog(rowData)}>
                                                    <i
                                                        className="far fa-eye"
                                                        data-tip="View Log"
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    />{" "}
                                                </span>
                                            )}
                                            {hasDownloadLog && rowData?.log_file && (
                                                <span onClick={() => hasDownloadLog(rowData)}>
                                                    <i
                                                        className="fas fa-file-download"
                                                        data-tip="Download Log"
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    />{" "}
                                                </span>
                                            )}
                                            {(hasMultiAction && hasInfoPage) || this.props.isBudgetPriority || this.props.hasViewIcon ? (
                                                <span
                                                    onClick={() => this.handleRowClick(rowData)}
                                                    data-tip="View Details"
                                                    data-effect="solid"
                                                    data-place="bottom"
                                                    data-for={`table`}
                                                    className={`${isRecommendationLog ? "text-center-eye" : ""}`}
                                                >
                                                    <i className="far fa-eye" />
                                                </span>
                                            ) : null}
                                            {hasEdit ? (
                                                <span
                                                    onClick={() => {
                                                        if (
                                                            (rowData?.asset_survey_status && rowData?.asset_survey_status === 5) ||
                                                            (rowData?.survey_status && rowData?.survey_status === 4) ||
                                                            (rowData?.asset_survey_project_status && rowData?.asset_survey_project_status === 4) ||
                                                            (this.props?.isSurveyRecom && rowData?.status === 4)
                                                        )
                                                            return;
                                                        else this.hadleEditButtonClick(rowData.id, rowData);
                                                    }}
                                                >
                                                    <i
                                                        className={`fas fa-pencil-alt ${
                                                            (rowData?.asset_survey_status && rowData?.asset_survey_status === 5) ||
                                                            (rowData?.survey_status && rowData?.survey_status === 4) ||
                                                            (rowData?.asset_survey_project_status && rowData?.asset_survey_project_status === 4) ||
                                                            (this.props?.isSurveyRecom && rowData?.status === 4)
                                                                ? "cursor-diabled"
                                                                : ""
                                                        }`}
                                                        data-tip={
                                                            this.props?.isSurveyRecom && rowData?.status === 4
                                                                ? "Can't edit a converted recommendation"
                                                                : (rowData?.asset_survey_status && rowData?.asset_survey_status === 5) ||
                                                                    (rowData?.survey_status && rowData?.survey_status === 4) ||
                                                                    (rowData?.asset_survey_project_status && rowData?.asset_survey_project_status === 4)
                                                                  ? rowData?.asset_survey_project_status === 4
                                                                      ? "Can't edit an asset from a completed survey project"
                                                                      : "Can't edit a completed asset"
                                                                  : `Edit`
                                                        }
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    />
                                                </span>
                                            ) : null}

                                            {hasAssignToTrade ? (
                                                <span
                                                    onClick={async () => {
                                                        await this.props.updateSelectedRow(rowData.id);
                                                        handleAssignToTrade(rowData);
                                                    }}
                                                >
                                                    <i class="fa fa-list-alt" title={`Assign to Trade`}></i>
                                                </span>
                                            ) : null}
                                            {hasAssignToSystem ? (
                                                <span
                                                    onClick={async () => {
                                                        await this.props.updateSelectedRow(rowData.id);
                                                        handleAssignToSystem(rowData);
                                                    }}
                                                >
                                                    <i class="fa fa-th-list" title={`Assign to System`}></i>
                                                </span>
                                            ) : null}
                                            {hasAssignToSubSystem ? (
                                                <span
                                                    onClick={async () => {
                                                        await this.props.updateSelectedRow(rowData.id);
                                                        handleAssignToSubSystem(rowData);
                                                    }}
                                                >
                                                    <i class="fa fa-list" title={`Assign to Sub System`}></i>
                                                </span>
                                            ) : null}
                                            {hasAssignToSpecialReport ? (
                                                <span
                                                    onClick={async () => {
                                                        await this.props.updateSelectedRow(rowData.id);
                                                        hasAssignToSpecialReport(rowData);
                                                    }}
                                                >
                                                    <i class="fa fa-server" title={`Assign to Special Report`}></i>
                                                </span>
                                            ) : null}
                                            {hasAssignToReportParagraph ? (
                                                <span
                                                    onClick={async () => {
                                                        await this.props.updateSelectedRow(rowData.id);
                                                        hasAssignToReportParagraph(rowData);
                                                    }}
                                                >
                                                    <i class="fa fa-bars" title={`Assign to Report Paragraph`}></i>
                                                </span>
                                            ) : null}
                                            {hasAssignToChildParagraph ? (
                                                <span
                                                    onClick={async () => {
                                                        await this.props.updateSelectedRow(rowData.id);
                                                        hasAssignToChildParagraph(rowData);
                                                    }}
                                                >
                                                    <i class="fa fa-tasks" title={`Assign to Child Paragraph`}></i>
                                                </span>
                                            ) : null}

                                            {handleSpecialReportActions ? (
                                                <>
                                                    <label
                                                        className="switch toggle-switch mr-2"
                                                        data-tip={rowData.project ? "Remove from projects" : "Add to projects"}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={rowData.project}
                                                            onChange={() => handleSpecialReportActions(rowData.id, { project: !rowData.project })}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label
                                                        className="switch toggle-switch mr-2"
                                                        data-tip={rowData.region ? "Remove from regions" : "Add to regions"}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={rowData.region}
                                                            onChange={() => handleSpecialReportActions(rowData.id, { region: !rowData.region })}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label
                                                        className="switch toggle-switch mr-2"
                                                        data-tip={rowData.site ? "Remove from sites" : "Add to sites"}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={rowData.site}
                                                            onChange={() => handleSpecialReportActions(rowData.id, { site: !rowData.site })}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                    <label
                                                        className="switch toggle-switch mr-2"
                                                        data-tip={rowData.building ? "Remove from buildings" : "Add to buildings"}
                                                        data-effect="solid"
                                                        data-place="bottom"
                                                        data-for={`table`}
                                                    >
                                                        <input
                                                            type="checkbox"
                                                            checked={rowData.building}
                                                            onChange={() => handleSpecialReportActions(rowData.id, { building: !rowData.building })}
                                                        />
                                                        <span className="slider round"></span>
                                                    </label>
                                                </>
                                            ) : null}
                                        </>
                                    )}
                                    {locked
                                        ? null
                                        : hasDelete && (
                                              <span onClick={() => handleDeleteItem(rowData.id, rowData.deleted || false, rowData)}>
                                                  <i
                                                      className="far fa-trash-alt"
                                                      data-tip={`Delete`}
                                                      data-effect="solid"
                                                      data-place="bottom"
                                                      data-for={`table`}
                                                  />
                                              </span>
                                          )}

                                    {hasEndTask &&
                                        rowData?.status !== "COMPLETED" &&
                                        rowData?.status !== "CANCELLED" &&
                                        rowData?.status !== 3 &&
                                        rowData?.status !== 4 &&
                                        rowData?.status !== 5 && (
                                            <span onClick={() => hasEndTask && hasEndTask(rowData?.task_id ?? rowData?.id)}>
                                                <i
                                                    className="fas fa-window-close"
                                                    data-tip="End Task"
                                                    data-effect="solid"
                                                    data-place="bottom"
                                                    data-for={`table`}
                                                ></i>
                                            </span>
                                        )}

                                    {hasLog && (
                                        <span onClick={() => hasLog && hasLog(rowData?.smart_export_id)}>
                                            <i
                                                className="fas fa-history"
                                                data-tip="View History"
                                                data-effect="solid"
                                                data-place="bottom"
                                                data-for={`table`}
                                            />{" "}
                                        </span>
                                    )}
                                    {hasErrorLog && rowData?.error_json && (
                                        <span onClick={() => hasErrorLog && hasErrorLog(rowData?.id)}>
                                            <i
                                                className="fas fa-history red-icn"
                                                data-tip="View Error Log"
                                                data-effect="solid"
                                                data-place="bottom"
                                                data-for={`table`}
                                            />{" "}
                                        </span>
                                    )}
                                    {hasSurveyAssign && (
                                        <span
                                            className="switch toggle-switch mr-2"
                                            data-tip={assignedRows?.includes(rowData?.id) ? "Click to unassign" : "Click to assign"}
                                            data-effect="solid"
                                            data-place="bottom"
                                            data-for={`table`}
                                            onClick={() => {
                                                handleSurveyAssign(rowData.id);
                                            }}
                                        >
                                            <input type="checkbox" checked={assignedRows?.includes(rowData?.id)} />
                                            <span className="slider round"></span>
                                        </span>
                                    )}
                                </li>
                            )}
                        </td>
                    ) : null}
                </tr>
                {this.state.view === "client" && config && config.users && config.users.isVisible && currentViewAllUsers === rowData.id ? (
                    <>
                        {keys.map(keyItem => {
                            if (config[keyItem] && config[keyItem].isVisible) {
                                columnCount += 1;
                            }
                        })}
                        <ViewAllUsers
                            users={rowData.users}
                            isViewClient={true}
                            colSpan={columnCount}
                            searchKeysArray={searchKeysArray}
                            client_users={rowData.client_users}
                        />
                    </>
                ) : null}
                {this.state.view === "consultancy" &&
                config &&
                config.client_users &&
                config.client_users.isVisible &&
                currentViewAllUsers === rowData.id ? (
                    <>
                        {keys.map(keyItem => {
                            if (config[keyItem] && config[keyItem].isVisible) {
                                columnCount += 1;
                            }
                        })}
                        <ViewAllClientUsers
                            colSpan={columnCount}
                            isViewClient={false}
                            searchKeysArray={searchKeysArray}
                            client_users={rowData.client_users}
                        />
                    </>
                ) : null}
            </React.Fragment>
        );
    }
}

export default withRouter(Row);
